import { image } from "../index";
export const pdfRender = async (arg) => {
    try {
        const { value } = arg;
        // @ts-ignore
        await image.pdf({ ...arg, value: value.data });
    }
    catch (error) {
        console.log(error);
    }
};
//# sourceMappingURL=pdfRender.js.map